import { render, staticRenderFns } from "./SubIntroApp.vue?vue&type=template&id=65c89531&"
import script from "./SubIntroApp.vue?vue&type=script&lang=js&"
export * from "./SubIntroApp.vue?vue&type=script&lang=js&"
import style0 from "./SubIntroApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports